module.exports = __webpack_public_path__ + "assets/img/fesBanner-lg.da8c091c.png";